import * as ko from "knockout";
import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import {nsForm} from "../../form/nsForm";
import {getNextId} from "../../../util/misc";
import bool2Str = nsForm.bool2Str;
import str2Bool = nsForm.str2Bool;
import booleanHtml from './boolean.html?raw';

export let template = booleanHtml;

export interface IParams_syncfield_boolean {
    val: KnockoutObservable<string>
}

export class viewModel {
    private readonly toggle: KnockoutObservable<boolean | null> = ko.observable(null);
    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker()
    private readonly name: string = 'radio-' + getNextId()

    constructor(private params: IParams_syncfield_boolean) {
        this.kosub.subscribe(this.toggle, (bool: boolean | null) => {
            this.params.val(bool2Str(bool ?? false))
        });
        this.kosub.subscribe(this.params.val, str => {
            this.toggle(str2Bool(str));
        });
        this.toggle(str2Bool(this.params.val()));
    }

    dispose() {
        this.kosub.unsuscribeAll()
    }
}
